/**
 * @file: 挂钉尺寸计算
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as FrontCubeData from '../../frontCubeData/index';
import * as Utils from '../../utils/util';

export function naiSize(cube: CubeNode): Size {
    let result: Size = {
        width: 0,
        height: 0
    };
    let nailId: string = FrontCubeData.getValue(cube.id, 'hangnailId');
    let nailData: FreeObjMap = FrontCubeData.getValue(cube.id, 'hangnailDetail');

    if (nailId && nailData) {
        result.width = Math.max(Utils.toNumberForce(nailData.labelWidth), Utils.toNumberForce(nailData.labelWidth));
        result.height = Utils.toNumberForce(nailData.labelHeight) + Utils.toNumberForce(nailData.backYspace);
    }

    return result;
}
